export const magicLink = {
  ContinueWithoutPassword: "Continue without password",
  Or: "Or",
} as const;
